import { apiSlice } from './apiSlice';

export const accrualTemplateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAccrualTemplates: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/accrual-templates/',
        params: params || {},
      }),
      providesTags: ['AccrualTemplate'],
    }),
    getAccrualTemplateById: builder.query<any, string | number>({
      query: (id) => {
        // Guard: an empty id produced /api/accrual-templates/undefined and
        // cached the resulting 404 under the list tag.
        if (id === null || id === undefined || id === '') {
          throw new Error('getAccrualTemplateById requires a valid id');
        }
        return { url: `/api/accrual-templates/${id}` };
      },
      providesTags: (result, error, id) => [{ type: 'AccrualTemplate', id }],
    }),
    createAccrualTemplate: builder.mutation<any, any>({
      query: (data) => ({
        url: '/api/accrual-templates/',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['AccrualTemplate'],
    }),
    updateAccrualTemplate: builder.mutation<any, { id: string | number; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/accrual-templates/${id}`,
        method: 'PUT',
        data: data,
      }),
      invalidatesTags: (result, error, arg) =>
        arg?.id !== undefined
          ? [{ type: 'AccrualTemplate', id: arg.id }, 'AccrualTemplate']
          : ['AccrualTemplate'],
    }),
    deleteAccrualTemplate: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `/api/accrual-templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AccrualTemplate'],
    }),
    generateForPeriod: builder.mutation<any, { periodStartDate: string; periodEndDate: string }>({
      query: (data) => ({
        url: '/api/accrual-templates/generate',
        method: 'POST',
        data: data,
      }),
      // Generation creates accrual records FROM the templates, so every cached
      // template entry (list + per-id) is stale afterwards.
      invalidatesTags: ['AccrualTemplate'],
    }),
    previewForPeriod: builder.mutation<any, { periodStartDate: string; periodEndDate: string }>({
      query: (data) => ({
        url: '/api/accrual-templates/preview',
        method: 'POST',
        data: data,
      }),
    }),
  }),
});

export const {
  useGetAccrualTemplatesQuery,
  useGetAccrualTemplateByIdQuery,
  useCreateAccrualTemplateMutation,
  useUpdateAccrualTemplateMutation,
  useDeleteAccrualTemplateMutation,
  useGenerateForPeriodMutation,
  usePreviewForPeriodMutation,
} = accrualTemplateApi;

